module.exports = __webpack_public_path__ + "static/img/200008.50a44f51.png";